import React from 'react';

const Error404 = () => <h1>Page Not Found</h1>;

export default Error404;
